import { CSSObject } from 'foundations-theming/utils';
import { createContext, useContext, PropsWithChildren } from 'react';

export interface TableContextProps extends PropsWithChildren {
  bordered: boolean;
  condensed: boolean;
  disableHover?: boolean;
  _exteriorBorders: boolean;
  tableVariantStyleOverrides?: CSSObject;
}

interface TableContextConfig {
  bordered: boolean;
  condensed: boolean;
  disableHover?: boolean;
  _exteriorBorders: boolean;
  tableVariantStyleOverrides?: CSSObject;
}

export const TableContext = createContext<TableContextConfig>({
  bordered: true,
  condensed: true,
  disableHover: false,
  _exteriorBorders: true,
  tableVariantStyleOverrides: undefined,
});

/**
 * Provides the context for the `Table` component.
 * @returns TableContext - The context for the `Table` component.
 */
export const useTableContext = () => {
  return useContext(TableContext);
};
